module.exports = __webpack_public_path__ + "static/media/Vicky.322f50a7.png";